import React from "react";
import PropTypes from "prop-types";

const CardCurve = ({ height, width, fill, ...rest }) => (
  <svg width={width} height="29" viewBox="0 0 160 29" fill="none" {...rest}>
    <path
      d="M0 0.636719V28.8185H160V0.636719C135.55 10.5745 108.5 16.1364 80 16.1364C51.5 16.1364 24.4502 10.5745 0 0.636719Z"
      fill={fill}
    />
  </svg>
);

CardCurve.propTypes = {
  height: PropTypes.number,
  width: PropTypes.string,
  fill: PropTypes.string,
};

CardCurve.defaultProps = {
  height: 29,
  width: 160,
  fill: "#ffffff",
};

export default CardCurve;
